import { set, child, onValue } from 'firebase/database'
import { proxy, useSnapshot } from 'valtio'

import * as firebaseConnection from '../firebaseConnection'

const ROOT_NODE = 'liveTranscription'

type LiveTranscription = {
  recentTranscriptionString: string
}

const liveTranscriptionState = proxy<LiveTranscription>({
  recentTranscriptionString: '',
})

firebaseConnection.runWhenReady((connection) => {
  // Adds a firebase listener to track the recent transcription string.
  onValue(
    child(child(connection.room, ROOT_NODE), 'recentTranscriptionString'),
    (snapshot) => {
      liveTranscriptionState.recentTranscriptionString = snapshot.val() ?? ''
    }
  )
})

const setLastTranscriptionMessage = async (message: string) => {
  const connection = await firebaseConnection.get()

  return set(
    child(child(connection.room, ROOT_NODE), 'recentTranscriptionString'),
    message
  ).catch((err: Error) => {
    connection.logError(
      'LIVE_TRANSCRIPTIONS',
      'Failed to set the most recent transcription string',
      err
    )
  })
}

const setTranscriptionStartTimestamp = async () => {
  const connection = await firebaseConnection.get()

  return set(
    child(child(connection.room, ROOT_NODE), 'transcriptionStartedAt'),
    Date.now()
  ).catch((err: Error) => {
    connection.logError(
      'LIVE_TRANSCRIPTIONS',
      'Failed to set the time of the beginning of the transcription',
      err
    )
  })
}

const useRecentTranscriptionString = () =>
  useSnapshot(liveTranscriptionState).recentTranscriptionString

export {
  liveTranscriptionState,
  useRecentTranscriptionString,
  setLastTranscriptionMessage,
  setTranscriptionStartTimestamp,
}
